(() => {
  function initMegaMenus() {
    const replayMegaStagger = (detail) => {
      const animatedItems = detail.querySelectorAll(
        '.dhw-luxury-level-mega__title, .dhw-luxury-level-mega__column, .dhw-luxury-level-mega__feature, .dhw-luxury-level-mega__social, .dhw-luxury-level-mega__bottom-bar'
      );

      if (!animatedItems.length) return;

      animatedItems.forEach((item) => {
        item.style.animation = 'none';
      });

      detail.offsetHeight;

      window.requestAnimationFrame(() => {
        animatedItems.forEach((item) => {
          item.style.animation = '';
        });
      });
    };

    const openMegaMenu = (detail, detailsItems) => {
      detailsItems.forEach((item) => { if (item !== detail) item.open = false; });
      detail.open = true;
      replayMegaStagger(detail);
    };

    document.querySelectorAll('[data-dhw-luxury-level-nav]').forEach((nav) => {
      const detailsItems = Array.from(nav.querySelectorAll('details'));
      detailsItems.forEach((detail) => {
        const summary = detail.querySelector('summary');
        const mode = detail.dataset.openMode || (detail.classList.contains('dhw-mega--click') ? 'click' : 'hover');

        if (mode === 'hover') {
          detail.addEventListener('mouseenter', () => {
            openMegaMenu(detail, detailsItems);
          });
          detail.addEventListener('mouseleave', () => {
            window.setTimeout(() => {
              if (!detail.matches(':hover') && !detail.contains(document.activeElement)) detail.open = false;
            }, 120);
          });
          detail.addEventListener('focusin', () => {
            openMegaMenu(detail, detailsItems);
          });
          detail.addEventListener('focusout', (event) => {
            if (!detail.contains(event.relatedTarget)) detail.open = false;
          });
          if (summary) {
            summary.addEventListener('click', (event) => {
              if (!window.matchMedia('(min-width: 1600px)').matches) return;
              event.preventDefault();
              if (!detail.open) openMegaMenu(detail, detailsItems);
            });
          }
        }

        if (mode === 'click' && summary) {
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const nextState = !detail.open;
            detailsItems.forEach((item) => item.open = false);
            detail.open = nextState;
            if (nextState) replayMegaStagger(detail);
          });
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') detailsItems.forEach((item) => item.open = false);
      });
      document.addEventListener('click', (event) => {
        if (!nav.contains(event.target)) detailsItems.forEach((item) => item.open = false);
      });
    });
  }

  function initMobileDrawer() {
    if (document.documentElement.dataset.dhwDrawerReady === 'true') return;
    document.documentElement.dataset.dhwDrawerReady = 'true';
    const desktop = window.matchMedia('(min-width: 1600px)');
    const close = (restoreFocus = true) => {
      const wasOpen = document.body.classList.contains('dhw-mobile-menu-open');
      document.body.classList.remove('dhw-mobile-menu-open');
      document.querySelector('.dhw-mobile-toggle')?.setAttribute('aria-expanded', 'false');
      document.getElementById('DHWMobileDrawer')?.setAttribute('aria-hidden', 'true');
      if (wasOpen && restoreFocus) document.querySelector('.dhw-mobile-toggle')?.focus();
    };
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.dhw-mobile-toggle');
      if (toggle && !desktop.matches) {
        const drawer = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!drawer) return;
        if (document.body.classList.contains('dhw-mobile-menu-open')) return close();
        document.body.classList.add('dhw-mobile-menu-open');
        toggle.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.querySelector('.dhw-mobile-drawer__close')?.focus();
      } else if (event.target.closest('[data-dhw-mobile-close], [data-dhw-premium-search-open]')) {
        close(!event.target.closest('[data-dhw-premium-search-open]'));
      }
    });
    document.addEventListener('keydown', (event) => {
      if (!document.body.classList.contains('dhw-mobile-menu-open')) return;
      if (event.key === 'Escape') return close();
      if (event.key !== 'Tab') return;
      const drawer = document.getElementById('DHWMobileDrawer');
      const items = Array.from(drawer.querySelectorAll('a[href], button, summary, [tabindex="0"]'))
        .filter(item => item.getClientRects().length && !item.disabled);
      const first = items[0];
      const last = items[items.length - 1];
      if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first)?.focus();
      }
    });
    desktop.addEventListener('change', () => { if (desktop.matches) close(false); });
    document.addEventListener('shopify:section:unload', () => close(false));
  }


  function initDHWAnnouncementOffset() {
    const bar = document.querySelector('.utility-bar');

    const setPastAnnouncement = (isPast) => {
      document.body.classList.toggle('dhw-past-announcement', isPast);
      document.querySelectorAll('.dhw-header-wrap[data-dhw-sticky-mode]').forEach((header) => {
        header.classList.toggle('dhw-header-wrap--past-announcement', isPast);
      });
    };

    const updateHeight = () => {
      const height = bar && bar.offsetParent !== null ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--dhw-announcement-bar-height', `${height}px`);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight, { passive: true });
    document.addEventListener('shopify:section:load', updateHeight);
    document.addEventListener('shopify:section:select', updateHeight);
    document.addEventListener('shopify:block:select', updateHeight);

    if (!bar || bar.offsetParent === null) {
      setPastAnnouncement(true);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      setPastAnnouncement(false);
      return;
    }

    // Tracking real visibility (rather than comparing scrollY to a
    // manually-measured height) keeps the header's flush-to-top snap in
    // sync with the announcement bar exactly, with no timing/rounding gap
    // that would otherwise show up as an overlap.
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[entries.length - 1];
        setPastAnnouncement(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(bar);
  }

  function initDHWScrollAnimation() {
    let ticking = false;
    let isHeaderScrolled = document.body.classList.contains('dhw-header-scrolled');

    const getScrollY = () => Math.max(
      window.scrollY || 0,
      document.documentElement ? document.documentElement.scrollTop || 0 : 0,
      document.body ? document.body.scrollTop || 0 : 0
    );

    const update = () => {
      const headers = document.querySelectorAll('.dhw-header-wrap[data-dhw-sticky-mode]');
      const scrollY = getScrollY();

      const hasStickyHeader = Array.from(headers).some(
        (header) => header.dataset.dhwStickyMode !== 'none'
      );

      headers.forEach((header) => {
        const stickyMode = header.dataset.dhwStickyMode;
        const section = header.closest('.shopify-section');
        const isDesktop = window.matchMedia('(min-width: 1600px)').matches;
        const isTransparentOverlay = isDesktop
          ? header.dataset.dhwTransparentHeader === 'true' && header.dataset.dhwTransparentHeaderOverlay === 'true'
          : header.dataset.dhwTransparentMobile === 'true';

        if (
          section &&
          !isTransparentOverlay &&
          isDesktop &&
          (stickyMode === 'nav_only' || stickyMode === 'nav_logo')
        ) {
          if (!header.classList.contains('dhw-header-wrap--scrolled')) {
            section.dataset.dhwHeaderFlowHeight = `${Math.ceil(header.getBoundingClientRect().height)}`;
          }

          const flowHeight = Number(section.dataset.dhwHeaderFlowHeight || 0);
          section.style.minHeight = flowHeight > 0 ? `${flowHeight}px` : '';
        } else if (section) {
          section.style.minHeight = '';
        }
      });

      // Separate enter/exit thresholds prevent the fixed header from rapidly
      // toggling when the browser is close to the activation point.
      isHeaderScrolled = hasStickyHeader && (isHeaderScrolled ? scrollY > 8 : scrollY > 40);

      if (isHeaderScrolled) {
        document.body.classList.add('dhw-header-scrolled');
      } else {
        document.body.classList.remove('dhw-header-scrolled');
      }

      headers.forEach((header) => {
        const stickyEnabled = header.dataset.dhwStickyMode !== 'none';
        header.classList.toggle('dhw-header-wrap--scrolled', isHeaderScrolled && stickyEnabled);
      });

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:section:select', requestUpdate);
    document.addEventListener('shopify:block:select', requestUpdate);
  }
  function initDHWSearchPopup() { return; }


  function initDHWPremiumSearchOnly() {
    if (document.documentElement.dataset.dhwPremiumSearchReady === 'true') return;
    document.documentElement.dataset.dhwPremiumSearchReady = 'true';

    const getPanel = () => document.getElementById('DHWPremiumSearch');
    const getTriggers = () => document.querySelectorAll('[data-dhw-premium-search-open]');
    let searchAbortController = null;
    let searchDebounceTimer = null;

    const escapeHTML = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const getSuggestEndpoint = (query) => {
      const root = window.Shopify?.routes?.root || '/';
      const cleanRoot = root.endsWith('/') ? root : `${root}/`;
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor',
      });

      return `${cleanRoot}search/suggest.json?${params.toString()}`;
    };

    const formatPrice = (price) => {
      if (!price) return '';
      if (typeof price === 'string') return price;
      const cents = Number(price);
      if (Number.isNaN(cents)) return '';

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'AUD',
      }).format(cents / 100);
    };

    const renderSearchResults = (panel, query, results) => {
      const container = panel ? panel.querySelector('[data-dhw-premium-search-results]') : null;
      if (!container) return;

      const products = results?.resources?.results?.products || [];
      const collections = results?.resources?.results?.collections || [];
      const suggestions = results?.resources?.results?.queries || [];
      const items = products.slice(0, 6);

      if (!query) {
        container.classList.remove('is-visible');
        container.innerHTML = '';
        return;
      }

      if (!items.length && !collections.length && !suggestions.length) {
        container.innerHTML = `
          <p class="dhw-premium-search__results-heading">Search results</p>
          <p class="dhw-premium-search__results-empty">No quick results found. Press enter to search for "${escapeHTML(query)}".</p>
        `;
        container.classList.add('is-visible');
        return;
      }

      const productMarkup = items.map((product) => {
        const image = product.featured_image?.url || product.image || '';
        const price = formatPrice(product.price || product.price_min);
        const title = escapeHTML(product.title);
        const url = product.url || `/products/${product.handle || ''}`;

        return `
          <li class="dhw-premium-search__result-item">
            <a class="dhw-premium-search__result-link" href="${url}">
              ${image ? `<img class="dhw-premium-search__result-image" src="${image}" alt="${title}" loading="lazy">` : '<span class="dhw-premium-search__result-image" aria-hidden="true"></span>'}
              <span>
                <span class="dhw-premium-search__result-title">${title}</span>
                ${price ? `<span class="dhw-premium-search__result-price">${escapeHTML(price)}</span>` : ''}
              </span>
            </a>
          </li>
        `;
      }).join('');

      const collectionMarkup = collections.slice(0, 2).map((collection) => `
        <li class="dhw-premium-search__result-item">
          <a class="dhw-premium-search__result-link" href="${collection.url}">
            <span class="dhw-premium-search__result-image" aria-hidden="true"></span>
            <span>
              <span class="dhw-premium-search__result-title">${escapeHTML(collection.title)}</span>
              <span class="dhw-premium-search__result-price">Collection</span>
            </span>
          </a>
        </li>
      `).join('');

      container.innerHTML = `
        <p class="dhw-premium-search__results-heading">Search results</p>
        <ul class="dhw-premium-search__results-list">${productMarkup}${collectionMarkup}</ul>
        <a class="dhw-premium-search__view-all" href="/search?q=${encodeURIComponent(query)}">View all results for "${escapeHTML(query)}"</a>
      `;
      container.classList.add('is-visible');
    };

    const updateSearchResults = (panel) => {
      const input = panel ? panel.querySelector('.dhw-premium-search__input') : null;
      const query = input ? input.value.trim() : '';

      window.clearTimeout(searchDebounceTimer);
      if (searchAbortController) searchAbortController.abort();

      if (!query) {
        renderSearchResults(panel, '', null);
        return;
      }

      searchDebounceTimer = window.setTimeout(() => {
        searchAbortController = new AbortController();
        fetch(getSuggestEndpoint(query), { signal: searchAbortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .then((results) => renderSearchResults(panel, query, results))
          .catch((error) => {
            if (error.name === 'AbortError') return;
            renderSearchResults(panel, query, null);
          });
      }, 180);
    };

    const updateClear = (panel) => {
      const input = panel ? panel.querySelector('.dhw-premium-search__input') : null;
      const clear = panel ? panel.querySelector('.dhw-premium-search__clear') : null;
      if (!clear || !input) return;
      clear.classList.toggle('is-visible', input.value.length > 0);
    };

    const open = () => {
      const panel = getPanel();
      if (!panel) return;
      const input = panel.querySelector('.dhw-premium-search__input');

      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dhw-premium-search-open');
      getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));

      window.setTimeout(() => {
        if (input) input.focus();
        updateClear(panel);
      }, 120);
    };

    const close = () => {
      const panel = getPanel();
      if (!panel) return;

      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dhw-premium-search-open');
      getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-dhw-premium-search-open]');
      if (openButton) {
        event.preventDefault();
        document.body.classList.remove('dhw-mobile-menu-open');
        document.querySelector('.dhw-mobile-toggle')?.setAttribute('aria-expanded', 'false');
        open();
        return;
      }

      const closeButton = event.target.closest('[data-dhw-premium-search-close]');
      if (closeButton) {
        event.preventDefault();
        close();
        return;
      }

      const clear = event.target.closest('.dhw-premium-search__clear');
      const panel = getPanel();
      if (clear) {
        const input = panel ? panel.querySelector('.dhw-premium-search__input') : null;
        event.preventDefault();
        if (!input) return;
        input.value = '';
        updateClear(panel);
        renderSearchResults(panel, '', null);
        input.focus();
        return;
      }

      if (panel && panel.classList.contains('is-open') && !event.target.closest('.dhw-premium-search__panel')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('input', (event) => {
      if (event.target.matches('.dhw-premium-search__input')) {
        const panel = getPanel();
        updateClear(panel);
        updateSearchResults(panel);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMegaMenus();
    initMobileDrawer();
    initDHWPremiumSearchOnly();
    initDHWAnnouncementOffset();
    initDHWScrollAnimation();
    initDHWSearchPopup();
    if (typeof initDHWMobileSearch === 'function') initDHWMobileSearch();
    if (typeof initDHWDropdownSearch === 'function') initDHWDropdownSearch();
    if (typeof initDHWSearchClearButton === 'function') initDHWSearchClearButton();
  });
})();
